export const assets = {
  copyIcon: 'assets/images/copyIcon.png',
  deleteIcon: 'assets/images/delete_icon.svg',
  DriverIcon: 'assets/images/driver_icon.svg',
  dropoffMarker: 'assets/images/drop-off-pin.png',
  logo: 'assets/images/esqyre_logo.svg',
  logoMin:'assets/images/logo_min.png',
  logo_1: 'assets/images/logo.png',
  navigator: 'assets/images/vehicle-icon.svg',
  noDataFound: 'assets/images/Nodat-found.gif',
  phoneIcon: 'assets/images/phone_icon.svg',
  pickupMarker: 'assets/images/pickup-pin.png',
  UsersIcon: 'assets/images/user_icon.svg',
  wareHouseIcon: 'assets/images/warehouse.png',
  rideDropOffIcon: 'assets/images/ride-dropOff-icon.svg',
  locationIcon: 'assets/images/location-icon.svg',
  ridePickUpIcon: 'assets/images/ride-pickUp-icon.png',
};
